export const lecturers = [
    {
        id: "Lektor 1",
        name: "Danuše",
        surname: "Kubová",
        description: "Na Základní škole jazyků Karlovy Vary učím němčinu, dějepis a informatiku, zároveň působím jako zástupkyně ředitelky, ICT koordinátorka a koordinátorka ŠVP. Digitální technologie mě baví a ráda je zkouším ve výuce – ale vždy tak, aby skutečně pomáhaly a nezahlcovaly učitele ani žáky. Mám letité zkušenosti s lektorováním workshopů a webinářů, působila jsem několik let jako krajský ICT metodik v rámci projektu SYPO a NPO. Mým cílem je ukázat, že digitalizace může být přirozená, užitečná a hlavně bez stresu.",
        image: "img/user_icon.png",
        before_name: "Mgr.",
        after_name: "",
        is_available: true,
        created_at: "2025-01-01",
        updated_at: "2025-01-01"
    }
]